import React from 'react';
import { SectionsLessonsTab } from '@/features/course-management';
import { superAdminCourseSectionsService } from '@/features/course-management/services/superAdminService';
import type { SectionWithLessons } from '@/features/course-management';

interface SuperAdminSectionsLessonsTabProps {
  courseId?: number;
  onUpdate?: (sections: SectionWithLessons[]) => void;
}

const SuperAdminSectionsLessonsTab: React.FC<SuperAdminSectionsLessonsTabProps> = ({ courseId, onUpdate }) => (
  <SectionsLessonsTab
    courseId={courseId}
    onUpdate={onUpdate}
    service={superAdminCourseSectionsService}
  />
);

export default SuperAdminSectionsLessonsTab;
